import axios from "axios";
import React, { useEffect, useState } from "react";
import "./DriverProfile.css";
import {
  ArrowDownLeft,
  ArrowUpRight,
  Cake,
  CalendarCheck,
  Circle,
  Clock,
  Mail,
  MessageSquare,
  Phone,
  Plus,
  Star,
  Truck,
  User,
  UserCog,
} from "lucide-react";
import van from "../../assets/images/Van.png";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";



const REVIEW_ENTITY_TYPES = {
  "App\\Models\\User": "customer",
  "App\\Models\\Stuff": "staff",
  "App\\Contexts\\Workforce\\Models\\Staff": "staff",
  "App\\Models\\DoorStepOrder": "order",
  "App\\Contexts\\Order\\Models\\DoorStepOrder": "order",
};

const REVIEW_TARGET_LABEL = {
  staff: "موظف",
  customer: "عميل",
  order: "الطلب",
  unknown: "طرف",
};

const getReviewEntityKind = (type) => REVIEW_ENTITY_TYPES[type]


const getReviewEntityName = (entity, kind) => {
  if (!entity) return "—";
  if (kind === "order") {
    return entity.reference || entity.order_number || `طلب #${entity.id}`;
  }
  return (
    entity.name || `${entity.first_name || ""} ${entity.last_name || ""}`.trim() || "—"
  );
};


const getReviewReasonList = (rev) => {
  const titles = rev.reason_titles;
  if (!titles || Array.isArray(titles)) return [];
  return Object.values(titles);
};

export default function DriverProfile() {

  const token = sessionStorage.getItem("token");
  const baseUrl = "https://estbn.com/EstbnNew/public/api";
  const headers = {
    Authorization: "Bearer " + token,
  };

  const formatDate = (dateString) => {
    if (!dateString) return "تاريخ غير محدد";

    const date = new Date(dateString);

    const datePart = date.toLocaleDateString("ar-EG", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });

    // const timePart = date.toLocaleTimeString("ar-EG", {
    //   hour: "numeric",
    //   minute: "2-digit",
    //   hour12: true,
    // });

    return `${datePart}`;
  };

  const [driverProfile, setDriverProfile] = useState(null);
  const [totalOrders, setTotalOrders] = useState(null);
  const [workingHours, setWorkingHours] = useState(null);
  const [activeTab, setActiveTab] = useState("notes");
  const [previewImage, setPreviewImage] = useState(null);
  const [notes, setNotes] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  const [expenseType, setExpenseType] = useState("");
  const [amount, setAmount] = useState("");
  const [notesValue, setNotesValue] = useState("");
  const [invoiceImage, setInvoiceImage] = useState(null);
  const [sentReviews, setSentReviews] = useState([]);
  const [receivedReviews, setReceivedReviews] = useState([]);
  const [reviewsSubTab, setReviewsSubTab] = useState("sent");

  const fileInputRef = React.useRef(null);

  const handleOpenInvoiceModal = () => {
    setShowInvoiceModal(true);
    setExpenseType("");
    setAmount("");
    setNotesValue("");
    setInvoiceImage(null);
  };

  const handleCloseInvoiceModal = () => {
    setShowInvoiceModal(false);
  };

  const handleImageChange = (file) => {
    setInvoiceImage(file);
  };

  const addInvoice = async () => {
    try {
      const formData = new FormData();

      formData.append("expense_type", expenseType);
      formData.append("amount", amount);
      formData.append("notes", notesValue);

      if (invoiceImage) {
        formData.append("images[]", invoiceImage);
      }

      await axios.post(`${baseUrl}/portal/stuff_expenses/add`, formData, {
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "multipart/form-data",
        },
      });
      toast.success("تم إضافة الفاتورة بنجاح", { autoClose: 3000 });
      handleCloseInvoiceModal();
      setExpenseType("");
      setAmount("");
      setNotesValue("");
      setInvoiceImage(null);
      getInvoices();
    } catch (error) {
      console.log(error);
    }
  };

  const getDriverProfile = async () => {
    try {
      let response = await axios.get(`${baseUrl}/portal/stuff/profile`, {
        headers,
      });
      const { driver_orders, engineer_orders } = response.data.data;
      setTotalOrders(driver_orders > 0 ? driver_orders : engineer_orders);
      console.log(response.data.data.profile);
      setDriverProfile(response.data.data.profile);
      setWorkingHours(response.data.data.working_hours);
    } catch (error) {
      console.log(error);
    }
  };

  const getNotes = async () => {
    try {
      let response = await axios.get(`${baseUrl}/stuff/get-notes  `, {
        headers,
      });
      console.log(response.data.data.notes);
      setNotes(response.data.data.notes);
    } catch (error) {
      console.log(error);
    }
  };

  const getInvoices = async () => {
    try {
      let response = await axios.get(`${baseUrl}/portal/stuff_expenses/get `, {
        headers,
      });
      console.log(response.data.data.expenses);
      setInvoices(response.data.data.expenses);
    } catch (error) {
      console.log(error);
    }
  };

  const getSentReviews = async () => {
    try {
      let response = await axios.get(`${baseUrl}/stuff/sent-reviews`, {
        headers,
      });
      setSentReviews(response.data.data.reviews);
    } catch (error) {
      console.log(error);
    }
  };

  const getReceivedReviews = async () => {
    try {
      let response = await axios.get(`${baseUrl}/stuff/received-reviews`, {
        headers,
      });
      setReceivedReviews(response.data.data.reviews);
    } catch (error) {
      console.log(error);
    }
  };

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, i) => (
      <Star
        key={i}
        size={15}
        fill={i < rating ? "#FFC400" : "none"}
        color="#FFC400"
      />
    ));
  };

useEffect(() => {
  getDriverProfile();
  getNotes();
  getInvoices();
  getSentReviews();
  getReceivedReviews();
}, []);

  return (
    <section className="driver-profile-section p-4">
      {/* image preview */}
      {previewImage && (
        <div
          className="image-preview-overlay"
          onClick={() => setPreviewImage(null)}
        >
          <div
            className="image-preview-container"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="preview-close-btn"
              onClick={() => setPreviewImage(null)}
            >
              ✕
            </button>

            <div className="preview-image-wrapper">
              <img src={previewImage} alt="preview" />
            </div>
          </div>
        </div>
      )}
      {/* add invoice modal */}
      <Modal
        show={showInvoiceModal}
        onHide={handleCloseInvoiceModal}
        centered
        className="details-modal"
        dir="rtl"
      >
        <Modal.Body className="p-4 text-end">
          <h5 className="text-center fw-bold mb-4">إضافة فاتورة</h5>
          {/* نوع الفاتورة */}
          <label className="mb-2 d-block small fw-semibold">نوع الفاتورة</label>
          <input
            type="text"
            className="form-control mb-4 rounded-3 p-3 bg-light border-0"
            placeholder="ادخل نوع الفاتورة"
            value={expenseType}
            onChange={(e) => setExpenseType(e.target.value)}
          />
          {/* المبلغ */}
          <label className="mb-2 d-block small fw-semibold">
            المبلغ المدفوع
          </label>
          <input
            type="number"
            className="form-control mb-4 rounded-3 p-3 bg-light border-0"
            placeholder="ادخل المبلغ المدفوع"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
          />
          {/* الوصف */}
          <label className="mb-2 d-block small fw-semibold">
            وصف الفاتورة (اختياري)
          </label>
          <textarea
            className="form-control mb-4 rounded-3 p-3 bg-light border-0"
            placeholder="اكتب وصف الفاتورة"
            rows="2"
            value={notesValue}
            onChange={(e) => setNotesValue(e.target.value)}
          ></textarea>
          {/* رفع الصورة */}
          <label className="mb-2 d-block small fw-semibold">
            ارفع صورة الفاتورة
          </label>
          <div
            className="upload-container text-center p-4 rounded-3 w-100 d-flex flex-column"
            onClick={() => fileInputRef.current.click()}
          >
            <input
              type="file"
              ref={fileInputRef}
              hidden
              onChange={(e) => handleImageChange(e.target.files[0])}
            />

            <div className="upload-icon my-0">
              <i className="bi bi-file-earmark-arrow-up fs-2 text-muted"></i>
            </div>

            <p className="my-0 fw-bold">اضف ملف</p>

            <p className="text-muted small my-0">
              أرفق صورة، فيديو، أو تسجيل صوتي.
            </p>

            {invoiceImage && (
              <div className="text-success small my-0">
                تم اختيار: {invoiceImage.name}
              </div>
            )}
          </div>

          {/* زرار الحفظ */}

          <button
            className="btn-modal-save w-100 mt-4 py-3 text-white fw-bold rounded-3"
            onClick={addInvoice}
          >
            حفظ
          </button>
        </Modal.Body>
      </Modal>
      {/* side profile & data */}
      <div className="row">
        {/* side profile */}
        <div className="col-4">
          <div className="profile-card border rounded-3">
            <div className="profile-card-header rounded-3 p-3">
              <div className="profile-role">
                <p className="my-0">
                  {driverProfile?.primary_job_title[0]?.title}
                </p>
              </div>
              <div className="profile-image-container">
                <img
                  src={`https://estbn.com/EstbnNew/public${driverProfile?.profile_photo_path}`}
                  alt="Profile"
                />
              </div>
            </div>
            <div className="profile-card-data mt-4 py-2 px-3 border-bottom border-1">
              <p className="profile-name">{driverProfile?.username}</p>
              <div className="profile-card-data-line d-flex justify-content-start align-items-center mb-3">
                <CalendarCheck size={18} />
                <p className="my-0 mx-2">
                  joined on {formatDate(driverProfile?.joined_at)}
                </p>
              </div>
              <div className="profile-card-data-line d-flex justify-content-start align-items-center my-3">
                <Phone size={18} />
                <p className="my-0 mx-2">{driverProfile?.phone_number}</p>
              </div>
              <div className="profile-card-data-line d-flex justify-content-start align-items-center my-3">
                <Cake size={18} />
                <p className="my-0 mx-2">
                  {formatDate(driverProfile?.birth_date)}
                </p>
              </div>
              <div className="profile-card-data-line d-flex justify-content-start align-items-center my-3">
                <User size={18} />
                <p className="my-0 mx-2">{driverProfile?.gender}</p>
              </div>
              <div className="profile-card-data-line d-flex justify-content-start align-items-center my-3">
                <UserCog size={18} />
                <p className="my-0 mx-2">{driverProfile?.username}</p>
              </div>
              <div className="profile-card-data-line d-flex justify-content-start align-items-center my-3">
                <Mail size={18} />
                <p className="my-0 mx-2">{driverProfile?.email}</p>
              </div>
            </div>
            <div className="profile-card-info p-3">
              <h3 className="mb-3">Agent Info</h3>
              <div className=" d-flex justify-content-start align-items-center my-2">
                <img src={van} width={20} alt="" />
                <p className="my-0 mx-2">
                  {driverProfile?.vehicles[0]?.name} -{" "}
                  {driverProfile?.vehicles[0]?.plate_number}
                </p>
              </div>
              <div className=" d-flex justify-content-start align-items-center my-2">
                <Star fill="#FFC400" color="#FFC400" size={18} />
                <p className="my-0 mx-2">4.8 Rates</p>
              </div>
              <div className=" d-flex justify-content-start align-items-center my-2">
                <Clock size={18} />
                <p className="my-0 mx-2">{workingHours}</p>
              </div>
              <div className=" d-flex justify-content-start align-items-center my-2">
                <Truck size={18} />
                <p className="my-0 mx-2">{totalOrders} Orders</p>
              </div>
              <div className=" d-flex justify-content-start align-items-center my-2">
                <Circle fill="#18AB00" size={18} color="#18AB00" />
                <p className="my-0 mx-2">Online</p>
              </div>
            </div>
          </div>
        </div>
        {/* data ( notes & invoices ) */}
        <div className="col-8">
          <div className="profile-data border rounded-3 p-3">
            {/* HEADER */}
            <div className="tabs-header d-flex justify-content-between align-items-center mb-3">
              {/* TABS */}
              <div className="tabs-container">
                <button
                  className={`tab-btn p-3 ${activeTab === "notes" ? "active" : ""}`}
                  onClick={() => setActiveTab("notes")}
                >
                  ملاحظات من الإدارة
                </button>
                <button
                  className={`tab-btn p-3 ${activeTab === "invoices" ? "active" : ""}`}
                  onClick={() => setActiveTab("invoices")}
                >
                  فواتير
                </button>
                <button
                  className={`tab-btn p-3 ${activeTab === "reviews" ? "active" : ""}`}
                  onClick={() => setActiveTab("reviews")}
                >
                  التقييمات
                </button>
              </div>
              {/* BUTTON */}
              <button className="add-btn m-0" onClick={handleOpenInvoiceModal}>
                {" "}
                <Plus size={18} /> إضافة فاتورة
              </button>
            </div>
            {/* CONTENT */}
            <div className="tabs-content">
              {/* notes */}
              {activeTab === "notes" &&
                notes.map((note) => (
                  <div key={note.id} className="note-card">
                    <div className="note-id">
                      #{note.id.toString().padStart(2, "0")} ملاحظة
                    </div>
                    <div className="note-title">{note.title}</div>
                    <p className="note-desc">{note.notes}</p>
                    <div className="note-footer">
                      <span>{formatDate(note.created_at)}</span>
                      <span>{note.created_by?.name}</span>
                    </div>
                  </div>
                ))}
              {/* invoices */}
              {activeTab === "invoices" &&
                invoices.map((inv) => (
                  <div key={inv.id} className="invoice-card">
                    <div className="fw-bold fs-5 my-2"> فاتورة #{inv.id}</div>
                    <div className="my-2">{inv.expense_type}</div>
                    <div className="my-2">{inv.notes}</div>
                    <div className="fw-bold my-2">{inv.amount}</div>
                    <div className="note-footer">
                      <span>{formatDate(inv.created_at)}</span>
                      {inv?.images?.length > 0 && (
                        <span
                          className="photo-view"
                          onClick={() =>
                            setPreviewImage(inv.images[0].full_image_url)
                          }
                        >
                          <b>photo_view</b> : صوره المخالفه
                        </span>
                      )}
                    </div>
                  </div>
                ))}

              {/* reviews */}
              {activeTab === "reviews" && (
                <div className="rvw-wrapper" dir="rtl">
                  <div className="rvw-tabs-toggle mb-3">
                    <button
                      className={`rvw-toggle-btn ${reviewsSubTab === "sent" ? "active" : ""}`}
                      onClick={() => setReviewsSubTab("sent")}
                    >
                      <ArrowUpRight size={16} />
                      تقييمات مرسلة
                    </button>
                    <button
                      className={`rvw-toggle-btn ${reviewsSubTab === "received" ? "active" : ""}`}
                      onClick={() => setReviewsSubTab("received")}
                    >
                      <ArrowDownLeft size={16} />
                      تقييمات واردة
                    </button>
                  </div>

                  {/* sent reviews — this staff member is the reviewer, so we show who they rated */}
                  {reviewsSubTab === "sent" &&
                    (sentReviews.length > 0 ? (
                      sentReviews.map((rev) => {
                        const targetKind = getReviewEntityKind(rev.reviewed_type);
                        const targetName = getReviewEntityName(rev.reviewed, targetKind);
                        const reasons = getReviewReasonList(rev);
                        // const subjectKind = getReviewEntityKind(rev.subject_type);
                        // const showOrderTag = subjectKind === "order" && rev.subject_id;

                        return (
                          <div key={rev.id} className="rvw-card">
                            <div className="rvw-card-header">
                              <div className="rvw-person">
                                <img
                                  className="rvw-avatar"
                                  src={
                                    rev.reviewed?.profile_photo_path
                                      ? `https://estbn.com/EstbnNew/public${rev.reviewed.profile_photo_path}`
                                      : van
                                  }
                                  alt="reviewed"
                                />
                                <div className="rvw-person-info">
                                  <p className="rvw-person-name">{targetName}</p>
                                  <p className="rvw-subtitle">
                                    <span className={`rvw-dot rvw-dot--${targetKind}`} />
                                    {targetKind === "order"
                                      ? "تقييم على الطلب"
                                      : `تقييم لـ ${REVIEW_TARGET_LABEL[targetKind]}`}
                                  </p>
                                </div>
                              </div>
                              <div className="rvw-stars">
                                {renderStars(rev.rating)}
                              </div>
                            </div>

                            {rev.comment && (
                              <p className="rvw-comment">
                                <MessageSquare size={14} />
                                <span>{rev.comment}</span>
                              </p>
                            )}

                            {reasons.length > 0 && (
                              <div className="rvw-reasons">
                                {reasons.map((reason, idx) => (
                                  <span key={idx} className="rvw-reason-chip">
                                    {reason}
                                  </span>
                                ))}
                              </div>
                            )}

                            <div className="rvw-footer">
                              {/* {showOrderTag && (
                                <span className="rvw-order-id">
                                  ضمن الطلب #{rev.subject_id}
                                </span>
                              )} */}
                              <span>{formatDate(rev.created_at)}</span>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div className="rvw-empty-state">
                        لا توجد تقييمات مرسلة
                      </div>
                    ))}

                  {/* received reviews — this staff member is being rated, so we show who rated them */}
                  {reviewsSubTab === "received" &&
                    (receivedReviews.length > 0 ? (
                      receivedReviews.map((rev) => {
                        const raterKind = getReviewEntityKind(rev.reviewable_type);
                        const raterName = getReviewEntityName(rev.reviewable, raterKind);
                        const reasons = getReviewReasonList(rev);
                        // const subjectKind = getReviewEntityKind(rev.subject_type);
                        // const showOrderTag = subjectKind === "order" && rev.subject_id;

                        return (
                          <div key={rev.id} className="rvw-card">
                            <div className="rvw-card-header">
                              <div className="rvw-person">
                                <img
                                  className="rvw-avatar"
                                  src={
                                    rev.reviewable?.profile_photo_path
                                      ? `https://estbn.com/EstbnNew/public${rev.reviewable.profile_photo_path}`
                                      : van
                                  }
                                  alt="reviewer"
                                />
                                <div className="rvw-person-info">
                                  <p className="rvw-person-name">{raterName}</p>
                                  <p className="rvw-subtitle">
                                    <span className={`rvw-dot rvw-dot--${raterKind}`} />
                                    {`تقييم من ${REVIEW_TARGET_LABEL[raterKind]}`}
                                  </p>
                                </div>
                              </div>
                              <div className="rvw-stars">
                                {renderStars(rev.rating)}
                              </div>
                            </div>

                            {rev.comment && (
                              <p className="rvw-comment">
                                <MessageSquare size={14} />
                                <span>{rev.comment}</span>
                              </p>
                            )}

                            {reasons.length > 0 && (
                              <div className="rvw-reasons">
                                {reasons.map((reason, idx) => (
                                  <span key={idx} className="rvw-reason-chip">
                                    {reason}
                                  </span>
                                ))}
                              </div>
                            )}

                            <div className="rvw-footer">
                              {/* {showOrderTag && (
                                <span className="rvw-order-id">
                                  ضمن الطلب #{rev.subject_id}
                                </span>
                              )} */}
                              <span>{formatDate(rev.created_at)}</span>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div className="rvw-empty-state">
                        لا توجد تقييمات واردة
                      </div>
                    ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}